








import { Vue, Component } from 'vue-property-decorator';

@Component
export default class NotFound extends Vue {
  message = '此链接已失效';
}
